// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"fc796183","20":"557756ec","390":"2258ab07","654":"7113f12f","716":"5bbbf8a3"}[chunkId] + ".chunk.js";
};